import axios, { AxiosResponse } from 'axios';

import { WorkAgreement, WorkAgreementDetails } from 'components/types';

import { toLocalISOString } from 'utils/date';
import { getCurrentlyLoggedInEmployeeId } from 'utils/misc';

import {
  EMPLOYEES_WORK_AGREEMENT_DETAILS,
  EMPLOYEES_WORK_AGREEMENTS
} from 'RestAPIs/endpoints';

const createAxiosInstance = () => {
  const instance = axios.create();

  instance.interceptors.response.use(
    (response: AxiosResponse<WorkAgreement[]>) => {
      response.data.forEach((wa) => {
        const { nr, functionDescription, brName, contractKind } = wa;
        wa.displayValue = `${nr} - ${functionDescription} - ${brName} - ${contractKind}`;
      });
      return response;
    }
  );
  instance.interceptors.request = axios.interceptors.request;

  return instance;
};

type Props = {
  startDate: Date;
  endDate: Date;
  employeeId?: number;
};

export const getEmployeeWorkAgreements = ({
  startDate,
  endDate,
  employeeId
}: Props) =>
  createAxiosInstance().get<WorkAgreement[]>(EMPLOYEES_WORK_AGREEMENTS, {
    params: {
      startDate: toLocalISOString(startDate),
      endDate: toLocalISOString(endDate)
    },
    pathParams: {
      employeeId: employeeId ?? getCurrentlyLoggedInEmployeeId()
    }
  });

type GetWorkAgreementDetailsOptions = {
  employeeId: number;
};

export const getWorkAgreementDetails = ({
  employeeId
}: GetWorkAgreementDetailsOptions) =>
  axios.get<WorkAgreementDetails[]>(EMPLOYEES_WORK_AGREEMENT_DETAILS, {
    pathParams: {
      employeeId
    }
  });
